import { useMutation as useGraphQLMutation } from "@apollo/client";
import { UpdateAppointmentInput } from "@/gql/graphql";
import {
  APPOINTMENTS_QUERY,
  UPDATE_APPOINTMENT_MUTATION,
  WAITING_TO_CONFIRM_APPOINTMENTS_QUERY,
} from "@/graphql/appointments";
import { useSalonStore } from "@/lib/store/salon";
import { cleanUpdateInput } from "../utils/appointment-utils";
import { sendWithOverCapacityApproval } from "../utils/over-capacity-approval";

export function useUpdateAppointment() {
  const { currentSalon } = useSalonStore();

  const [updateAppointmentMutation, { loading: isUpdating }] = useGraphQLMutation(
    UPDATE_APPOINTMENT_MUTATION,
    {
      // Refresh the calendar list and the waiting-to-confirm list (which also
      // feeds the "Confirm" badge in the calendar header).
      refetchQueries: [APPOINTMENTS_QUERY, WAITING_TO_CONFIRM_APPOINTMENTS_QUERY],
      onError: (error) => {
        console.error("Error updating appointment:", error);
      },
    }
  );

  const updateAppointment = async (
    appointmentId: string,
    updates: Partial<UpdateAppointmentInput>
  ) => {
    if (!currentSalon?.id) {
      throw new Error("No salon selected");
    }

    const salonId = currentSalon.id;
    return await sendWithOverCapacityApproval((acknowledgement) =>
      updateAppointmentMutation({
        variables: {
          salonId,
          appointmentId,
          input: cleanUpdateInput({ ...updates, ...acknowledgement }),
        },
      })
    );
  };

  return {
    updateAppointment,
    isUpdating,
  };
}
